module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/lion-2.8d10775b.png";